<template>
    <div class="upgrade-annual-toggle">
        <div class="annual-toggle">
            <div>
                <SwitchToggle :config="toggleConfig" @toggle="toggle"></SwitchToggle>
            </div>
            <div class="subtitle-text">{{ getSubTitle }}</div>
        </div>
        <p class="upgrade-annual-disclaimer" v-show="disclaimer">
            {{ disclaimer }}
        </p>
    </div>
</template>

<script>
    import SwitchToggle from 'atoms/SwitchToggle';
    import { mapState } from 'vuex';
    import Product from 'aa/vue/models/Product';
    import Domain from 'helpers/Domain';

    export default {
        name: 'UpgradeAnnualToggle',
        components: {
            SwitchToggle,
        },
        props: {
            planType: {
                type: String,
            },
        },
        computed: {
            ...mapState('pageAttributes', {
                pageAttr: (state) => state.attributes,
            }),
            disclaimer() {
                return this.pageAttr?.aa_payment_upgrade_to_annual_disclaimer ?? '';
            },
            toggleConfig() {
                return {
                    id: 'toggle',
                    value: this.planType !== Product.TYPE_MONTHLY,
                    displayTexts: {
                        Off: this.getTitle,
                        On: this.getTitle,
                    },
                };
            },
            getSubTitle() {
                return this.pageAttr?.aa_payment_upgrage_to_annual_sub_title ?? '';
            },
            getTitle() {
                return this.pageAttr?.aa_payment_upgrage_to_annual_title ?? '';
            },
            isInternational() {
                return Domain.isInternational();
            },
        },
        methods: {
            toggle(action) {
                this.$emit('filterAndSelect', action);
            },
        },
    };
</script>
